/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { OasSchemaFactory } from '../../core/factories/OasSchemaFactory';
import { Document } from '../../core/models/Document';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20SchemaDefinition } from '../../openapi/v2/models/Oas20SchemaDefinition';
import { NewSchemaDefinitionCommand } from './NewSchemaDefinitionCommand';
import { Oas20Definitions } from '../../openapi/v2/models/Oas20Definitions';
import { IDefinition } from '../../core/models/common/IDefinition';

/**
 * @author eric.wittmann@gmail.com
 * @extends NewSchemaDefinitionCommand
 * @class
 */
export class NewSchemaDefinitionCommand_20 extends NewSchemaDefinitionCommand {
    public _nullDefinitions : boolean;

    public constructor(definitionName? : any, example? : any, description? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((example != null) || example === null) && ((typeof description === 'string') || description === null)) {
            let __args = arguments;
            super();
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
            (() => {
                this._newDefinitionName = definitionName;
                this._newDefinitionExample = example;
                this._newDefinitionDescription = description;
            })();
        } else if(definitionName === undefined && example === undefined && description === undefined) {
            let __args = arguments;
            super();
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewDefinitionCommand] Executing.");
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this.isNullOrUndefined(doc20.definitions)) {
            doc20.definitions = doc20.createDefinitions();
            this._nullDefinitions = true;
        }
        if(this.isNullOrUndefined(doc20.definitions.getDefinition(this._newDefinitionName))) {
            let definition : Oas20SchemaDefinition;
            if(!this.isNullOrUndefined(this._newDefinitionExample)) {
                definition = <Oas20SchemaDefinition><any>OasSchemaFactory.createSchemaDefinitionFromExample(doc20, this._newDefinitionName, this._newDefinitionExample);
                definition.example = this._newDefinitionExample;
            } else {
                definition = doc20.definitions.createSchemaDefinition(this._newDefinitionName);
                definition.type = "object";
            }
            if(ModelUtils.isDefined(this._newDefinitionDescription)) {
                definition.description = this._newDefinitionDescription;
            }
            doc20.definitions.addDefinition(this._newDefinitionName, definition);
            this._defExisted = false;
        } else {
            this._defExisted = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewDefinitionCommand] Reverting.");
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this._nullDefinitions) {
            doc20.definitions = null;
        }
        if(this._defExisted) {
            return;
        }
        doc20.definitions.removeDefinition(this._newDefinitionName);
    }
}
NewSchemaDefinitionCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.NewSchemaDefinitionCommand_20";
NewSchemaDefinitionCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




